import React from 'react';
import {
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonProgressBar,
} from '@ionic/react';
import './FarecardCappingCard.css';
import { FarecardCappingPot } from '../../services/types/apitypes';
import { useTranslation } from 'react-i18next';

type FarecardCappingCardProps = {
  pot: FarecardCappingPot;
  onClick?: () => void;
};

export default function FarecardCappingCard({
  pot,
  onClick,
}: FarecardCappingCardProps): React.ReactElement {
  const [t] = useTranslation('global');

  return (
    <IonList className="pt-2">
      <IonItem
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-option"
        button={!!onClick}
        onClick={onClick}
      >
        <IonIcon
          slot="start"
          src="assets/icon/fare-capping-icon.svg"
          className="fare-capping-icon"
        ></IonIcon>
        <IonLabel className="fare-cappin-info">
          <h2>{pot.name}</h2>
          <p>
            {t('farecapping.fareCappingLeftToEarn')}
            <strong>{pot.missingValue}</strong>
          </p>
          <div className="fare-capping-progress-container">
            <IonProgressBar
              className="fare-capping-progress"
              value={pot.currentValue / pot.amount}
            />
            <p>{pot.amount}</p>
          </div>
        </IonLabel>
      </IonItem>
    </IonList>
  );
}
